import { render, staticRenderFns } from "./kdCarinfo.vue?vue&type=template&id=541c68dd"
import script from "./kdCarinfo.vue?vue&type=script&lang=js"
export * from "./kdCarinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports